import jsPDF from "jspdf";
import "jspdf-autotable";
import { getComplianceRow } from "@thequantumhub/iam-package";

const exportPDF = (timeLabels, complianceResults) => {
  const doc = new jsPDF();

  const columns = ["Item", ...timeLabels, "Total Compliance %"];

  const data = Object.entries(complianceResults).map(([item, timeData]) => {
    const rowData = getComplianceRow(item, timeData, timeLabels);

    return rowData;
  });

  doc.autoTable({
    head: [columns],
    body: data,
    styles: {
      lineColor: [0, 0, 0], // Color of the lines
      lineWidth: 0.5, // Width of the lines
    },
  });

  doc.save("ComplianceTable.pdf");
};

export default exportPDF;
